<template>
  <div>
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title>
          <v-row>
            <v-col class="d-flex align-center">
              <img
                width="50px"
                class="mr-2 rounded-circle"
                src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/other/itowokashi.webp"
              >
              ラッシュデュエルラボ 入手方法管理 ver1.51
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-row>
          <v-col class="d-flex justify-end">
            <v-btn color="primary" dark @click="editItem()">
              <v-icon>mdi-new-box</v-icon>入手方法新規追加
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>
    </div>

    <v-card class="ma-6"></v-card>
    <v-card class="ma-6">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        id="data_search"
        class="mx-4 pa-4"
        placeholder="検索"
        clearable
      ></v-text-field>

      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :items-per-page="100"
        :footer-props="{ itemsPerPageOptions: [50, 100, 200, -1] }"
      >
        <template v-slot:item.edit="{ item }">
          <v-icon color="primary" @click="editItem(item)">fas fa-edit</v-icon>
        </template>

        <template v-slot:item.short_code="{ item }">
          <v-layout align-center justify-center>
            <v-btn color="deep-orange" dark @click="copyToClipboard(item)">
              <div class="button font-weight-bold">SC</div>
            </v-btn>
          </v-layout>
        </template>

        <template v-slot:item.img="{ item }">
          <v-container fluid fill-height @click="editItem(item)">
            <v-layout align-center justify-center>
              <img width="50" :src="'https://appmedia.jp'+item.img" v-if="item.img != ''">
              <img
                width="50"
                src="https://appmedia.jp/wp-content/uploads/2018/05/d837eaf7abe6ea4fb462811cab15a451.jpg"
                v-else
              >
            </v-layout>
          </v-container>
        </template>

        <template v-slot:item.name="{ item }">
          <div @click="editItem(item)" text>{{ item.name }}</div>
        </template>

        <template v-slot:item.type="{ item }">
          <div @click="editItem(item)" text>{{ item.type }}</div>
        </template>

        <template v-slot:item.url="{ item }">
          <div @click="editItem(item)" text>{{ item.url }}</div>
        </template>

        <template v-slot:item.del="{ item }">
          <v-icon size="32" color="red" @click="delItem(item.id, item.name)">mdi mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <!-- 編集画面 -->
    <v-row justify="center">
      <v-dialog
        v-model="showDialog"
        scrollable
        persistent
        max-width="1500px"
        height="95vh"
        @click:outside="showDialog = false"
      >
        <v-card width="800" :disabled="loading">
          <v-overlay color="grey lighten-2" :absolute="true" :value="loading">
            <v-progress-circular :size="70" :width="7" color="yellow darken-4" indeterminate></v-progress-circular>
          </v-overlay>

          <v-card-title class="pa-0">
            <v-row class="pa-4 ml-1" width="100%">
              <v-col cols="10">入手方法情報編集</v-col>
              <v-col cols="2" class="text-right pr-5">
                <v-icon large color="blue darken-1" @click="closeDialog()">mdi-close-thick</v-icon>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <div class="contents">
              <v-row class="pr-4 pl-4 ml-1" width="100%">
                <v-col cols="1" class="mt-5">
                  <img
                    v-if="target_item.img != ''"
                    width="100"
                    :src="'https://appmedia.jp'+target_item.img"
                  >
                  <img
                    v-else
                    width="100"
                    src="https://appmedia.jp/wp-content/uploads/2018/05/d837eaf7abe6ea4fb462811cab15a451.jpg"
                  >
                </v-col>
                <v-col cols="11">
                  <v-row class="pr-4 pl-4 ml-1" width="100%">
                    <v-col cols="8">
                      <v-text-field
                        label="入手方法名"
                        hide-details="auto"
                        class="pa-0"
                        :rules="rules"
                        v-model="target_item.name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <!-- <v-text-field
                        label="タイプ"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_item.type"
                      ></v-text-field>-->
                      <v-select label="入手方法タイプ" :items="category_list" v-model="target_item.type"></v-select>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" width="100%">
                    <v-col cols="10">
                      <v-text-field
                        label="画像パス(/wp-content〜)"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_item.img"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        label="個別記事URL"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_item.url"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" width="100%">
                    <v-col>
                      <v-textarea
                        rows="5"
                        class="custom_textarea pt-0 pb-0"
                        auto-grow
                        outlined
                        v-model="target_item.remarks"
                        label="備考"
                        counter="1000"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col cols="6" class="d-flex align-center pl-8">
                <v-btn class="font-weight-bold" width="100" color="blue" dark @click="saveItem()">
                  <v-icon small color="white">mdi-check-bold</v-icon>更新
                </v-btn>
                <v-btn
                  width="100"
                  class="ml-4 font-weight-bold"
                  color="red"
                  dark
                  @click="delItem(target_item.id, target_item.name)"
                >
                  <v-icon small color="white">mdi-delete</v-icon>削除
                </v-btn>
              </v-col>
              <v-col cols="6" class="d-flex justify-end">
                <v-btn
                  class="pr-5 font-weight-bold"
                  color="blue darken-1"
                  text
                  @click="closeDialog()"
                >閉じる</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout" top>
      {{ snackbarText }}
      <v-btn color="white" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// Ajax通信ライブラリ
import axios from "axios";

export default {
  components: {},

  data() {
    return {
      detail_cards_list: [],

      snackbar: false,
      snackbarText: "",
      snackbarColor: "info",
      timeout: 2000,

      dialog: false,
      overlay: false,

      category_list: ["パック", "ストラク", "キャラ", "イベント"],

      showDialog: false,

      loading: false,

      headers: [
        {
          text: "編集",
          align: "center",
          value: "edit",
          sortable: false,
          width: "7%"
        },
        {
          text: "ｼｮｰﾄｺｰﾄﾞ",
          value: "short_code",
          width: "11%",
          align: "left"
        },
        {
          text: "アイコン",
          value: "img",
          width: "10%",
          align: "center"
        },
        {
          text: "入手方法名",
          value: "name",
          width: "40%",
          align: "left"
        },

        {
          text: "タイプ",
          value: "type",
          width: "15%",
          align: "center"
        },
        {
          text: "URL",
          value: "url",
          width: "10%",
          align: "center"
        },
        {
          text: "削除",
          value: "del",
          width: "7%",
          align: "center"
        }
      ],

      rules: [value => !!value || "入力必須"],

      target_item: {},
      getmaster_data_cols: [],

      target_post_type: "",

      // //検索用パラメータ
      search: "",

      list: [],

      // // 入力規則
      required: value => !!value || "必ず入力してください" // 入力必須の制約
    };
  },

  computed: {},

  //---------------------------
  // 読み込み時に実行
  //---------------------------
  created: function() {
    // 入手方法一覧
    this.getGetMethodList();
    // 入手方法テーブルのカラムを取得
    this.getGetMasterCols();
  },

  methods: {
    //---------------------------
    // スナックバー
    // わざわざalertで出さなくてもいいかなって時に
    //---------------------------
    showSnackbar(text) {
      this.snackbarText = text;
      this.snackbar = true;
    },

    //---------------------------
    // 入手方法リスト取得
    //---------------------------
    getGetMethodList() {
      axios.get(process.env.VUE_APP_RD_GETMASTER_LIST).then(response => {
        // v-data-tableを使うときは配列に格納する
        const items = [];
        const values = Object.values(response.data);
        values.forEach(value => {
          items.push(value);
        });
        this.list = items;
      });
    },

    //---------------------------
    // ショートコードコピー
    //---------------------------
    copyToClipboard(item) {
      event.stopPropagation();
      var sctype = "";
      if (item.type == "ストラク" || item.type == "パック") {
        sctype = " type='" + item.type + "'";
      }

      var text =
        "[yugioh_rd_sc article='pack_info' id='" + item.id + "'" + sctype + "]";

      var copyTextarea = document.createElement("textarea");
      copyTextarea.style.position = "fixed";
      copyTextarea.style.opacity = "0";
      copyTextarea.textContent = text;

      document.body.appendChild(copyTextarea);
      copyTextarea.select();
      document.execCommand("copy");
      document.body.removeChild(copyTextarea);

      this.showSnackbar(
        "《" + item.name + "》のショートコードをコピーしました！"
      );
    },

    //---------------------------
    // 編集画面
    //---------------------------
    editItem(item) {
      if ((item === void 0) === false) {
        // item(取得した入手方法データ)をターゲット配列にコピー
        this.target_item = Object.assign({}, item);

        this.target_post_type = "update";
      } else {
        // ターゲット配列を初期化
        this.getmaster_data_cols.forEach(value => {
          this.target_item[value] = "";
        });

        this.target_post_type = "insert";
      }

      this.showDialog = true;
    },

    //---------------------------
    // 入手方法テーブルのカラム取得
    //---------------------------
    getGetMasterCols() {
      axios.get(process.env.VUE_APP_RD_GETMASTER_COLS).then(response => {
        const items = [];
        const values = Object.values(response.data);
        values.forEach(value => {
          items.push(value.cols);
        });

        this.getmaster_data_cols = items;
      });
    },

    //---------------------------
    // 更新
    //---------------------------
    saveItem() {
      if (this.target_item.name == "" || this.target_item.name == null) {
        alert("入手方法名を入力してください");
        return;
      }

      if (this.target_item.type == "" || this.target_item.type == null) {
        alert("入手方法種別を入力してください");
        return;
      }

      var msg = "";
      if (this.target_post_type == "insert") {
        msg = "新規登録";
      } else {
        msg = "更新";
      }
      if (
        !window.confirm(
          "「" +
            this.target_item.name +
            "」を" +
            msg +
            "します。よろしいですか？"
        )
      ) {
        return;
      }

      this.loading = true;

      var item = {};

      // ターゲット配列をphpに投げる
      this.getmaster_data_cols.forEach(value => {
        var tmp_data = "";
        if (value == "id") {
          tmp_data = Number(this.target_item[value]);
        } else {
          tmp_data = this.target_item[value];
        }
        item[value] = tmp_data;
      });

      item.post_type = this.target_post_type;

      console.log(item);

      axios
        .post(process.env.VUE_APP_RD_GETMASTER_UPDATE, {
          data: item
        })

        .then(response => {
          console.log(response.data);
          alert("「" + item.name + "」を更新しました！");
          this.showDialog = false;
          this.getGetMethodList();
        })
        .catch(error => {
          alert(
            "予期せぬエラーが発生しました。エンジニアまでご連絡ください。\n" +
              error
          );
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });

      this.getdataFilePut();
    },

    //---------------------------
    // 削除
    //---------------------------
    delItem(id, name) {
      if (!window.confirm("「" + name + "」を削除します。よろしいですか？")) {
        return;
      }

      var item = {
        id: Number(id),
        post_type: "delete"
      };

      axios
        .post(process.env.VUE_APP_RD_GETMASTER_UPDATE, {
          data: item
        })

        .then(response => {
          console.log(response.data);
          alert("削除しました！");
          this.showDialog = false;
          this.getGetMethodList();
        })
        .catch(error => {
          alert(
            "予期せぬエラーが発生しました。エンジニアまでご連絡ください。\n" +
              error
          );
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });

      this.getdataFilePut();

      this.showDialog = false;
    },

    //---------------------------
    // jsonファイル出力
    //---------------------------
    getdataFilePut() {
      axios
        .get(process.env.VUE_APP_RD_JSON_UPLOAD, {
          params: {
            json_type: "getmaster"
          }
        })

        .then(response => {
          console.log(response.data);
          // alert("アップロードしました！");
        })
        .catch(error => {
          console.log(error);
          // alert("予期せぬエラーが発生しました。\n" + error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // ダイアログ閉じ
    //---------------------------
    closeDialog() {
      this.showDialog = false;
    }
  },

  watch: {},

  beforeCreate: function() {}
};
</script>

<style>
/* .sc_label {
  border: 2px solid #f44336 !important;
  color: #f44336 !important;
  border-radius: 10px !important;
} */
/* .deck_list {
  display: flex;
  flex-wrap: wrap;
}
.deck_list li {
  display: inline-block;
  width: 12%;
  text-align: center;
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 20px;
} */
</style>
